<template>
  <div>
    <div>
      <div class="trust-search">
        <el-form :inline="true" :model="queryForm" @submit.native.prevent>
          <el-form-item label="机构名称">
            <el-input
              v-model="queryForm.licenseName"
              placeholder="请输入机构名称"
              clearable
              style="width: 220px;"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select
              v-model="queryForm.auditStatus"
              placeholder="请选择审核状态"
              clearable
              style="width: 160px;"
            >
              <el-option label="通过" value="通过"></el-option>
              <el-option label="待审核" value="待审核"></el-option>
              <el-option label="退回" value="退回"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权开始时间">
            <el-date-picker
              v-model="queryForm.authorizedStartTime"
              type="date"
              placeholder="请选择授权开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 220px;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="display: flex;justify-content: space-between; margin-bottom: 10px;">
        <div> 
          <el-button @click="allpassPdf" type="primary" :disabled="!canBatchOperate">批量通过</el-button>
          <el-button @click="allblackPdf" type="primary" :disabled="!canBatchOperate">批量退回</el-button>
        </div>
        <div style="position: relative;">
          <el-button @click="allDownloadPdf" type="primary" >批量下载</el-button>
          <div v-if="num>0" class="numClass">{{num}}</div>
        </div>
      </div>
      <div style="margin-top: 20px;">
        <el-table
          ref="multipleTable"
          :data="trustTableData"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
          :row-key="getRowKey"
        >
          <el-table-column type="selection" width="55" :selectable="isSelectable"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="enterpriseName" label="名称">
            <template slot-scope="{ row }">
              <span>{{ row.enterpriseName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="上传时间" width="160">
            <template slot-scope="{ row }">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="状态" width="100">
            <template slot-scope="{ row }">
              <span>{{ row.auditStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="auditStatus" label="机构名称">
            <template slot-scope="{ row }">
              <span>{{ row.licenseName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="{ row }">
              <el-button @click="previewPdf(row)" type="text">预览</el-button>
              <el-button :disabled="!isPending(row)" @click="rowkeypassPdf(row)" type="text">审核通过</el-button>
              <el-button :disabled="!isPending(row)" @click="rowkeyblackPdf(row)" type="text">❌</el-button>
              <el-button @click="downPdf(row)" type="text" style="padding-left: 10px;">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div style="text-align: right; margin-top:30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="trustTotal"
        ></el-pagination>
      </div>
      <!-- 预览弹框 -->
      <el-dialog
        title="预览"
        :visible.sync="previewDialogVisible"
        width="80%"
        top="5vh"
        :close-on-click-modal="false"
        append-to-body
        @close="closePreview"
      >
        <div class="preview-box">
          <iframe
            v-if="previewUrl && previewType === 'pdf'"
            :src="previewUrl"
            frameborder="0"
          ></iframe>
          <img
            v-else-if="previewUrl && previewType === 'image'"
            :src="previewUrl"
            class="preview-image"
            alt="预览图片"
          />
          <div v-else class="preview-empty">加载中...</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closePreview">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 退回备注弹框 -->
      <el-dialog
        title="退回"
        :visible.sync="rejectDialogVisible"
        width="40%"
        :close-on-click-modal="false"
        append-to-body
      >
        <el-form :model="rejectForm" label-width="80px">
          <el-form-item label="备注">
            <el-input
              v-model="rejectForm.remark"
              type="textarea"
              :rows="5"
              maxlength="500"
              show-word-limit
              placeholder="请输入退回备注"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelReject">取 消</el-button>
          <el-button type="primary" @click="confirmReject">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 批量下载弹框 -->
    <el-dialog
      title="批量下载"
      :visible.sync="archiveDialogVisible"
      width="80%"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="archive-search">
        <el-form :inline="true" :model="archiveQueryForm">
          <el-form-item label="压缩包名">
            <el-input
              v-model="archiveQueryForm.archiveName"
              placeholder="请输入压缩包名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="机构名称">
            <el-input
              v-model="archiveQueryForm.financeName"
              placeholder="请输入机构名称"
              clearable
              filterable
              style="width: 220px;"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select
              v-model="archiveQueryForm.type"
              placeholder="请选择状态"
              clearable
              style="width: 160px;"
            >
              <el-option label="未下载" :value="0"></el-option>
              <el-option label="已下载" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleArchiveSearch">查询</el-button>
            <el-button @click="handleArchiveReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="archiveTableData" style="width: 100%;" border>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="archiveName" label="压缩包名称" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.archiveName }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="orgName" label="机构名称" min-width="200">
          <template slot-scope="{ row }">
            <span>{{ row.financeName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="上传时间" width="170">
          <template slot-scope="{ row }">
            <span>{{ row.createTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.type === 1 ? 'success' : 'info'" size="small">
              {{ row.type === 1 ? '已下载' : '未下载' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button
              @click="downArchive(row)"
              type="text"
            >下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 20px;">
        <el-pagination
          @size-change="archiveSizeChange"
          @current-change="archiveCurrentChange"
          :page-size="archivePage.pageSize"
          :current-page.sync="archivePage.page"
          layout="total, prev, pager, next, jumper"
          :total="archiveTotal"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="archiveDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { bankList, cerditCentePass, selectArchiveFileList, downloadArchiveFile } from "../../../api/bankcrecenter.js";
import { checkinList } from "../../../api/loglistinfo.js";
import baseUrl from "@/api/baseUrl";
import { selectNewDemand } from "@/api/login";
export default {
  data() {
    return {
      fileArray: [],
      bankTitle: "",
      selectedItems: [], // 所有选中的项目（包括已审核的）
      selectedPendingItems: [], // 仅选中的待审核项目
      batchLoading: false,
      //   actionType: "", // 'approve' or 'reject'
      bankFromPage: {
        page: 1,
        pageSize: 10
      },
      num:0,
      // 列表查询参数
      queryForm: {
        licenseName: "",
        auditStatus: "",
        authorizedStartTime: ""
      },
      trustTotal: null,
      // dialogUpload: false,
      modeUploadForm: {},
      // 信用中心
      trustTableData: [],
      // 批量下载弹框
      archiveDialogVisible: false,
      archiveQueryForm: {
        archiveName: "",
        financeName: "",
        type: ""
      },
      archivePage: {
        page: 1,
        pageSize: 5
      },
      archiveTableData: [],
      archiveTotal: 0,
      orgOptions: [],
      // 预览弹框
      previewDialogVisible: false,
      previewUrl: "",
      previewType: "", // pdf / image
      // 退回备注弹框
      rejectDialogVisible: false,
      rejectForm: {
        remark: ""
      },
      rejectRow: null
    };
  },
  computed: {
    // 是否可以执行批量操作
    canBatchOperate() {
      return this.selectedPendingItems.length > 0 && !this.batchLoading;
    }
  },
  mounted() {
    this.trustData();
    selectNewDemand().then(res => {
        if (res.data.code === 200) {
          console.log(res.data.data);
          try{
            this.num = res.data.data.licenseSum || 0;
          }catch(err){
            console.log(err);
          }
        }
      })
  },
  methods: {
    // 组装查询参数
    buildQueryParams() {
      const params = {
        page: this.bankFromPage.page,
        pageSize: this.bankFromPage.pageSize
      };
      if (this.queryForm.licenseName) {
        params.licenseName = this.queryForm.licenseName;
      }
      if (this.queryForm.auditStatus) {
        params.auditStatus = this.queryForm.auditStatus;
      }
      if (this.queryForm.authorizedStartTime) {
        params.authorizedStartTime = this.queryForm.authorizedStartTime;
      }
      return params;
    },
    // 查询
    handleSearch() {
      this.bankFromPage.page = 1;
      this.trustData();
    },
    // 重置
    handleReset() {
      this.queryForm = {
        licenseName: "",
        auditStatus: "",
        authorizedStartTime: ""
      };
      this.bankFromPage.page = 1;
      this.trustData();
    },
    
    // 获取审批列表
    async trustData() {
      try {
        const res = await bankList(this.buildQueryParams());
        this.trustTableData = res.data.data || [];
        this.trustTotal = res.data.pageInfo.total;
        this.clearInvalidSelections();
      } catch (error) {
        // this.$message.error(error.message || "获取数据失败");
      } finally {
        // this.loading = false;
      }
    },

    // 清除无效的选择
    clearInvalidSelections() {
      this.$nextTick(() => {
        const invalidSelections = this.selectedItems.filter(
          item => !this.isPending(item)
          // console.log(this.item, "invalidSelections")
        );

        if (invalidSelections.length > 0) {
          invalidSelections.forEach(item => {
            this.$refs.multipleTable.toggleRowSelection(item, false);
          });
          this.selectedItems = this.selectedItems.filter(item =>
            this.isPending(item)
          );
        }
      });
    },

    // 获取行唯一标识
    getRowKey(row) {
      return row.id;
    },
    // 判断是否是pending状态
    isPending(row) {
      return row.auditStatus == "待审核";
    },
    // 判断行是否可选
    isSelectable(row) {
      //   return row.auditStatus == 0;
      return this.isPending(row);
    },
    // 选择项变化
    handleSelectionChange(val) {
      this.selectedItems = val;
      // 筛选出待审核的项目
      this.selectedPendingItems = val.filter(
        item => item.auditStatus == "待审核"
      );
    },
    // 单个通过
    async rowkeypassPdf(row) {
      try {
        const res = await cerditCentePass({
          auditStatus: "通过",
          ids: [row.id]
        });
        if (res.data.code == 200) {
          this.$message.success(`已通过: ${row.enterpriseName}`);
        }
        this.trustData();
      } catch (error) {
        this.$message.error(error.message || "操作失败");
      }
    },
    // 单个拒绝：打开退回备注弹框
    rowkeyblackPdf(row) {
      this.rejectRow = row;
      this.rejectForm.remark = "";
      this.rejectDialogVisible = true;
    },
    // 取消退回：关闭弹框并清空输入
    cancelReject() {
      this.rejectDialogVisible = false;
      this.rejectForm.remark = "";
      this.rejectRow = null;
    },
    // 确定退回：携带 remark 提交
    async confirmReject() {
      if (!this.rejectRow) return;
      const row = this.rejectRow;
      const remark = this.rejectForm.remark;
      try {
        const res = await cerditCentePass({
          auditStatus: "退回",
          ids: [row.id],
          remark
        });
        if (res.data.code == 200) {
          this.$message.warning(`已退回: ${row.enterpriseName}`);
        }
        this.rejectDialogVisible = false;
        this.rejectForm.remark = "";
        this.rejectRow = null;
        this.trustData();
      } catch (error) {
        this.$message.error(error.message || "操作失败");
      }
    },
    // 下载
    downPdf(row) {
      // 编码转译
      const encodedPath = encodeURIComponent(row.licensePath);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl +
          `/api/v1/bankLicense/downloadFile?licensePath=${encodedPath}`,
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = row.licensePath;
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send();
    },
    // 根据文件头判断是图片还是 PDF
    sniffFileType(blob) {
      return new Promise(resolve => {
        const fallback = { type: "pdf", mime: "application/pdf" };
        if (!blob) return resolve(fallback);
        const reader = new FileReader();
        reader.onload = () => {
          const arr = new Uint8Array(reader.result);
          const toHex = list =>
            Array.from(list)
              .map(b => ("0" + b.toString(16)).slice(-2))
              .join("");
          const hex = toHex(arr.slice(0, 8));
          const ascii = String.fromCharCode.apply(null, arr.slice(0, 4));
          if (hex.indexOf("ffd8ff") === 0)
            return resolve({ type: "image", mime: "image/jpeg" });
          if (hex.indexOf("89504e47") === 0)
            return resolve({ type: "image", mime: "image/png" });
          if (ascii === "GIF8")
            return resolve({ type: "image", mime: "image/gif" });
          if (hex.indexOf("424d") === 0)
            return resolve({ type: "image", mime: "image/bmp" });
          if (ascii === "RIFF" && String.fromCharCode.apply(null, arr.slice(8, 12)) === "WEBP")
            return resolve({ type: "image", mime: "image/webp" });
          if (ascii === "%PDF" || ascii.indexOf("%PD") === 0)
            return resolve({ type: "pdf", mime: "application/pdf" });
          return resolve(fallback);
        };
        reader.onerror = () => resolve(fallback);
        reader.readAsArrayBuffer(blob.slice(0, 12));
      });
    },
    // 判断预览类型：扩展名 -> blob.type -> 文件头
    resolvePreviewType(blob, licensePath) {
      const imageMimeMap = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        bmp: "image/bmp",
        webp: "image/webp",
        svg: "image/svg+xml"
      };
      const ext = (String(licensePath || "").split(".").pop() || "").toLowerCase();
      if (imageMimeMap[ext]) {
        return Promise.resolve({ type: "image", mime: imageMimeMap[ext] });
      }
      if (ext === "pdf") {
        return Promise.resolve({ type: "pdf", mime: "application/pdf" });
      }
      const blobType = (blob && blob.type) || "";
      if (blobType.indexOf("image/") === 0) {
        return Promise.resolve({ type: "image", mime: blobType });
      }
      if (blobType.indexOf("pdf") > -1) {
        return Promise.resolve({ type: "pdf", mime: "application/pdf" });
      }
      return this.sniffFileType(blob);
    },
    // 预览：在当前页弹窗中展示
    previewPdf(row) {
      this.releasePreviewUrl();
      this.previewUrl = "";
      this.previewType = "";
      this.previewDialogVisible = true;
      const encodedPath = encodeURIComponent(row.licensePath);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "get",
        this.baseUrl +
          `/api/v1/bankLicense/downloadFile?licensePath=${encodedPath}`,
        true
      );
      xhr.responseType = "blob";
      xhr.setRequestHeader("token", sessionStorage.getItem("token"));
      xhr.onload = () => {
        const blob = xhr.response;
        console.log("[预览调试] HTTP状态:", xhr.status, "Content-Type:", xhr.getResponseHeader("Content-Type"), "Blob大小:", blob.size);

        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result;
          console.log("[预览调试] Blob前200字:", text.substring(0, 200));

          if (xhr.status === 200) {
            const contentType = xhr.getResponseHeader("Content-Type") || "";
            if (contentType.includes("application/json") || contentType.includes("xml") || text.trim().startsWith("{") || text.trim().startsWith("<")) {
              let errMsg = text;
              try { errMsg = JSON.parse(text).msg || JSON.parse(text).message || text; } catch(e) {}
              this.$message.error("后端返回了错误: " + errMsg);
              return;
            }
            this.resolvePreviewType(blob, row.licensePath).then(({ type, mime }) => {
              // 后端可能返回 octet-stream，需按真实类型重建 blob，图片才能被浏览器渲染
              const previewBlob = mime && mime !== blob.type ? new Blob([blob], { type: mime }) : blob;
              this.previewType = type;
              this.previewUrl = window.URL.createObjectURL(previewBlob);
            });
          } else {
            let errMsg = text;
            try { errMsg = JSON.parse(text).msg || JSON.parse(text).message || text; } catch(e) {}
            this.$message.error("预览失败: HTTP " + xhr.status + " - " + errMsg);
          }
        };
        reader.readAsText(blob);
      };
      xhr.onerror = () => {
        this.$message.error("网络错误，无法预览");
      };
      xhr.send();
    },
    // 关闭预览弹窗
    closePreview() {
      this.previewDialogVisible = false;
      this.releasePreviewUrl();
      this.previewUrl = "";
      this.previewType = "";
    },
    // 释放预览的 blob 地址
    releasePreviewUrl() {
      if (this.previewUrl) {
        window.URL.revokeObjectURL(this.previewUrl);
      }
    },
    // 批量操作确认
    async confirmBatchAction(auditStatus) {
      const list = this.selectedPendingItems;
      if (!list.length) return false;
      const actionText = auditStatus === "通过" ? "通过" : "退回";
      const namesHtml = list
        .map(item => `<div>${item.enterpriseName || "-"}</div>`)
        .join("");
      try {
        await this.$confirm(
          `<div>确定要${actionText}选中的 ${list.length} 个机构吗? 操作不可撤销。</div>
           <div style="max-height:180px;overflow:auto;margin-top:8px;text-align:left;">${namesHtml}</div>`,
          "提示",
          {
            confirmButtonText: `确认${actionText}`,
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        );
        return true;
      } catch (error) {
        return false;
      }
    },
    // 批量提交审核结果
    async submitBatchAudit(auditStatus) {
      const confirmed = await this.confirmBatchAction(auditStatus);
      if (!confirmed) {
        this.$message.info("已取消操作");
        return;
      }
      const list = this.selectedPendingItems;
      const actionText = auditStatus === "通过" ? "通过" : "退回";
      this.batchLoading = true;
      try {
        const ids = list.map(item => item.id);
        const res = await cerditCentePass({ auditStatus, ids });
        if (res.data.code == 200) {
          const msg = `已批量${actionText} ${list.length} 项`;
          if (auditStatus === "通过") {
            this.$message.success(msg);
          } else {
            this.$message.warning(msg);
          }
        }
        this.$refs.multipleTable.clearSelection();
        this.trustData();
      } catch (error) {
        this.$message.error(error.message || "批量操作失败");
      } finally {
        this.batchLoading = false;
      }
    },
    // 批量通过
    allpassPdf() {
      this.submitBatchAudit("通过");
    },
    //批量退回
    allblackPdf() {
      this.submitBatchAudit("退回");
    },
    // 分页
    handleSizeChange(val) {
      this.bankFromPage.pageSize = val;
      this.trustData(this.bankFromPage);
    },
    handleCurrentChange(val) {
      this.bankFromPage.page = val;
      this.trustData(this.bankFromPage);
    },
    // ===== 批量下载弹框相关 =====
    async allDownloadPdf() {
      this.archiveDialogVisible = true;
      if (!this.orgOptions.length) {
        await this.loadOrgOptions();
      }
      this.archivePage.page = 1;
      this.fetchArchiveList();
    },
    async loadOrgOptions() {
      try {
        const res = await checkinList({ page: 1, pageSize: 9999 });
        this.orgOptions = (res.data && res.data.data) || [];
      } catch (e) {
        this.orgOptions = [];
      }
    },
    async fetchArchiveList() {
      try {
        const params = {
          page: this.archivePage.page,
          pageSize: this.archivePage.pageSize,
          archiveName: this.archiveQueryForm.archiveName || undefined,
          financeName: this.archiveQueryForm.financeName || undefined,
          type: this.archiveQueryForm.type === "" || this.archiveQueryForm.type === null ? undefined : this.archiveQueryForm.type
        };
        const res = await selectArchiveFileList(params);
        const data = res.data && res.data.data;
        console.log("[批量下载] 列表数据:", data);
        if (data) {
          this.archiveTableData = data.records || data.list || data || [];
          this.archiveTotal = res.data.pageInfo.total || 0;
        } else {
          this.archiveTableData = [];
          this.archiveTotal = 0;
        }
      } catch (e) {
        this.archiveTableData = [];
        this.archiveTotal = 0;
        this.$message.error("获取列表失败");
      }
    },
    handleArchiveSearch() {
      this.archivePage.page = 1;
      this.fetchArchiveList();
    },
    handleArchiveReset() {
      this.archiveQueryForm = { archiveName: "", financeName: "", type: "" };
      this.archivePage.page = 1;
      this.fetchArchiveList();
    },
    archiveSizeChange(val) {
      this.archivePage.pageSize = val;
      this.fetchArchiveList();
    },
    archiveCurrentChange(val) {
      this.archivePage.page = val;
      this.fetchArchiveList();
    },
    async downArchive(row) {
      try {
        const res = await downloadArchiveFile({ id: row.id });
        const blob = new Blob([res.data || res], { type: "application/octet-stream" });
        const fileName = row.archiveName || "archive.zip";
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        }
        this.$message.success("下载成功");
        this.fetchArchiveList();
      } catch (e) {
        this.$message.error("下载失败");
      }
    }
  }
};
</script>

<style>
.numClass{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: -10px;
  top: -10px;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background-color: #f56c6c;
  color: #fff;
  font-weight: bold;
  line-height: 1;
  font-size: 12px;
  box-shadow: 0 0 0 2px #fff;
}
.trust-search {
  margin-bottom: 10px;
}
.trust-search .el-form-item {
  margin-bottom: 10px;
}
.preview-box {
  width: 100%;
  height: 70vh;
}
.preview-box iframe {
  width: 100%;
  height: 100%;
}
.preview-image {
  max-width: 100%;
  max-height: 100%;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}
.preview-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}
</style>